<script>
import { num1K1MParts } from '../common.js';

export let bgCssClass = 'bg-primary'
export let iconClass = 'fas fa-bicycle';
export let title = '-';
export let description = '...';
export let figure2019 = '1000';
export let figure2020 = '800';
export let units = '';
export let decimalPlaces = 0;

let figureTarget2019;
let figureTarget2020;

$: figureParts2019 = num1K1MParts(figure2019, decimalPlaces, 0);
$: figureParts2020 = num1K1MParts(figure2020, decimalPlaces, 0);

</script>

<section class="{`${bgCssClass} sectionx hero is-fullheight`}">
  <div class="hero-body">
    <div class="container">
        <div class="ioreveal animate__animated" data-anicss="animate__fadeInDown">
          <h2><i class="{iconClass}"></i> {title}</h2>
          <p> {description}</p>
        </div>
      <div class="flex-parent">
        <div class="flex-child">
          <div
            class="ioreveal animate__animated animate__delay-2s"
            style="animation-delay: 0.2s;"
            data-anicss="animate__fadeInUp">
            <h1 class="has-text-primary text-2019">
              <span
                data-countup="{figureParts2019.num}"
                data-countup-decplaces="{decimalPlaces}"
                bind:this="{figureTarget2019}">0</span><span>{figureParts2019.suffix || ''}</span>
              <span class="units">{units}</span>
            </h1>
            <p class="text-2019">2019</p>
          </div>
        </div>
        <div class="flex-child">
          <div
            class="ioreveal animate__animated animate__delay-2s"
            style="animation-delay: 0.5s;"
            data-anicss="animate__fadeInUp">
            <h1 class="has-text-primary text-2020">
              <span
                data-countup="{figureParts2020.num}"
                data-countup-decplaces="{decimalPlaces}"
                bind:this="{figureTarget2020}">0</span><span>{figureParts2020.suffix || ''}</span>
              <span class="units">{units}</span>
            </h1>
            <p class="text-2020">2020</p>
          </div>
        </div>
      </div>

      {#if units.indexOf("min") <= -1}
      <div class="note">
        <p>
        <strong>M</strong> - million
        </p>
        <p>
        <strong>K</strong> - thousand
        </p>
      </div>
      {/if}

    </div>
  </div>
</section>

<style>
.note {
  margin-top: 15px;
}
.note p {
  opacity: .5;
  font-size: 16px;
}
@media (max-width: 640px) {
  h1 {
    font-size: 2.5rem;
  }
}
</style>